import RecordBase from './Base';
import { useTranslation } from 'react-i18next';

export default class AppointmentTagsRecord extends RecordBase {
  static defaultAttributes = {
    name: '',
    created_at: '',
    updated_at: '',
  };

  static _attributeNames = null;

  static get attributeNames() {
    const { t } = useTranslation();
    const trAttr = (attr) => t(`appointmentTags.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        name: trAttr('name'),
        created_at: trAttr('created_at'),
        updated_at: trAttr('updated_at'),
      };
    }

    return this._attributeNames;
  }

  toParams(attrs = {}) {
    const { name, created_at, updated_at } = this.toObject();

    return {
      data: {
        attributes: {
          name,
          created_at,
          updated_at,
          ...attrs,
        },
      },
    };
  }
}
